import { request } from './httpClient';

/**
 * Salesforce eCommerce proxy (Tenant API → Apex). For portal inventory browse/search use
 * getMarketplaceCatalog in inventory.js (Cosmos-backed).
 */
export function getProducts(params) {
  return request({ method: 'GET', url: '/v1/products', params });
}

export function getProduct(productId) {
  return request({ method: 'GET', url: `/v1/product/${encodeURIComponent(productId)}` });
}

export function getInventoriesByProduct(productId, params) {
  return request({ method: 'GET', url: `/v1/inventories/${encodeURIComponent(productId)}`, params });
}

export function getInventory(inventoryId) {
  return request({ method: 'GET', url: `/v1/inventory/${encodeURIComponent(inventoryId)}` });
}

export function getPrices(partId, params) {
  return request({ method: 'GET', url: `/v1/prices/${encodeURIComponent(partId)}`, params });
}

